import { render } from "./RegisterItensForm.vue?vue&type=template&id=7ff08a46&scoped=true"
import script from "./RegisterItensForm.vue?vue&type=script&lang=js"
export * from "./RegisterItensForm.vue?vue&type=script&lang=js"

import "./RegisterItensForm.vue?vue&type=style&index=0&id=7ff08a46&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff08a46"]])

export default __exports__